import Breadcrumb from "../Component/Breadcrumb";
const ParentCorner = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="Parents Corner"
        breadmid="Academic"
        breadend="Parents Corner"
      />
      <div className="innerpage library_blk">
        <div className="container">
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/parent1.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/parent1.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/parent2.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/parent2.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/parent3.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/parent3.jpg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ParentCorner;
